import React from 'react'
import ReactDOM from 'react-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { StripeProvider } from 'react-stripe-elements';

import { payShipback, freeShipback } from '../actions/shipback'
import { setBreadcrumb } from '../actions/breadcrumb'

import { getShipbackPrice } from '../assets/utils'

import { POSTAL, DROPOFF, PICKUP, INSTRUCTIONS } from '../assets/constant'

import PaidReturn from './PaidReturn'

class FreeReturn extends React.Component {

  render() {
    return (
      <div className="free">
        <h2>{I18n.t('shipbacks.checkouts.free.title')}</h2>

        <p className="instructions"><span dangerouslySetInnerHTML={{__html: I18n.t('shipbacks.checkouts.free.instructions_html')}}></span></p>
        <div className="col-12">
          <a href="#" className="submit mb-3" onClick={this.props.onFreeShipback} >
            {I18n.t('shipbacks.checkouts.free.submit')}
          </a>
        </div>
      </div>
    )
  }
}

class ReturnCheckout extends React.Component {

  constructor(props) {
    super()
    this.props = props
    this.state =  {price: null}
    this.onFreeShipback = this.onFreeShipback.bind(this)
    this.initCheckout = this.initCheckout.bind(this)
  }

  componentWillMount() {
    this.initCheckout()
  }

  initCheckout() {
    this.setState({ price: getShipbackPrice(this.props.shipback.quotes, this.props.shipback.mode) })
  }

  onFreeShipback() {
    this.props.freeShipback(shipback_id, this.props.user_token)
  }

  render() {
    if (this.state.price != null) {
      if (this.state.price == 0) {
        return (
          <FreeReturn onFreeShipback={this.onFreeShipback}/>
        )
      } else {
        return (
          <StripeProvider apiKey={stripe_token}>
            <PaidReturn amount={this.state.price} />
          </StripeProvider>
        )
      }
    }
  }
}

const mapStateToProps = state => ({
  shipback: state.shipback,
  user_token: state.user,
})

const mapDispatchToProps = dispatch => bindActionCreators({ payShipback, setBreadcrumb, freeShipback }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ReturnCheckout)


// WEBPACK FOOTER //
// ./app/javascript/components/components/ReturnCheckout.jsx